var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91178 23.9629H7.67723V11.9617H11.013L11.3704 7.92931H7.67723V5.52908C7.67723 4.59299 7.86784 4.20895 8.7971 4.20895H11.3704V0.00854492H8.05846C4.5082 0.00854492 2.91178 1.59269 2.91178 4.61698V7.83331H0.529053V11.9137H2.91178V23.9629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFacebook);
export default __webpack_public_path__ + "static/media/white-facebook.c94bb40dcd87a1ed806bb383a2373c71.svg";
export { ForwardRef as ReactComponent };